module.exports = __webpack_public_path__ + "static/media/wre3.png.1e5aada2.jpg";